<template>
  <j-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="model" :rules="validatorRules">

        <!-- <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="imageUrl" label="图片连接">
          <a-input placeholder="请输入图片连接" v-model="model.imageUrl" />
        </a-form-model-item> -->
        <a-form-model-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            prop="imageUrl"
            label="图片"
          >
            <!--          <a-input placeholder="请输入活动图片地址" v-model="model.picUrl" />-->
            <j-image-upload
              text="上传图片"
              :otherData="{
                compress: 1
              }"
              v-model="model.imageUrl"
              :isMultiple="true"
              :bizPath="'dayMind'"
            ></j-image-upload>
          </a-form-model-item>

        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="imageUrl"
          label="图片-带二维码"
        >
          <j-image-upload
            text="上传图片"
            :otherData="{
                compress: 1
              }"
            v-model="model.imageUrl2"
            :isMultiple="true"
            :bizPath="'dayMind'"
          ></j-image-upload>
        </a-form-model-item>

        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="imageDate" label="日期">
          <a-date-picker v-model="model.imageDate"/>
        </a-form-model-item>

      </a-form-model>
    </a-spin>
  </j-modal>
</template>

<script>
import { httpAction } from '@/api/manage'
import moment from "moment"
import JImageUpload from '@/components/jeecg/JImageUpload'
export default {
  name: "DailyImageModal",
  components: {
    JImageUpload
  },
  data() {
    return {
      title: "操作",
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },

      confirmLoading: false,
      validatorRules: {
      },
      url: {
        add: "/dailyImage/add",
        edit: "/dailyImage/edit",
      },
    }
  },
  created() {
  },
  methods: {
    add() {
      //初始化默认值
      this.edit({});
    },
    edit(record) {
      this.model = Object.assign({}, record);
      this.visible = true;
    },
    close() {
      this.$emit('close');
      this.visible = false;
      this.$refs.form.clearValidate();
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.$refs.form.validate(valid => {
        if (valid) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'put';
          }
          httpAction(httpurl, this.model, method).then((res) => {
            if (res.success) {
              that.$message.success(res.message);
              that.$emit('ok');
            } else {
              that.$message.warning(res.message);
            }
          }).finally(() => {
            that.confirmLoading = false;
            that.close();
          })
        } else {
          return false;
        }
      })
    },
    handleCancel() {
      this.close()
    },


  }
}
</script>

<style lang="less" scoped></style>